import { getTranslationByPartnerAccess } from '../../../../helpers/getTranslationByPartnerAccess'
import { ITranslationOptions } from '../../../../models/translationOptions'

export const getAmplifyTrackFieldLabelTranslation = ({
  isGlobalPartner,
  isDistributor,
  isRetail,
}: ITranslationOptions) => {
  if (isGlobalPartner) {
    return 'jbp-gp360-basic-info--amplify-track'
  }

  if (isDistributor) {
    return 'partnerbasicinfo-distributor-key'
  }

  return getTranslationByPartnerAccess('partnerbasicinfo-amplify-track', { isRetail })
}
